module.exports = __webpack_public_path__ + "img/zdravje.57e66cac.svg";